import { ProximityPolicyDistanceConstraintFragment } from '@warebee/frontend/data-access-api-graphql';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilState, useRecoilValue } from 'recoil';
import InputCheckbox from '../components/inputs/InputCheckbox';
import InputNumber from '../components/inputs/InputNumber';
import TitleSection from '../components/layout/TitleSection';
import { PolicyCardItem } from '../components/policies/PolicyCardItem';
import { getProximityConstraintTypeOptions } from './proximityPolicy.helper';
import {
  proximityPolicyRule,
  proximityPolicySelectedIdentity,
} from './proximityPolicy.state';

const ProximityPolicyConstraintsEditor: React.FC = () => {
  const { t } = useTranslation('simulation');
  const selectedIdentity = useRecoilValue(proximityPolicySelectedIdentity);
  const [rule, updateRule] = useRecoilState(
    proximityPolicyRule(selectedIdentity?.ruleId),
  );
  if (selectedIdentity?.type !== 'constraints' || !rule) return null;

  function update(patch: Partial<ProximityPolicyDistanceConstraintFragment>) {
    updateRule(current => ({
      ...current,
      constraint: [
        {
          ...current?.constraint?.[0],
          distance: {
            ...current?.constraint?.[0]?.distance,
            ...patch,
          },
        },
      ],
    }));
  }
  const distanceConstraints = rule.constraint[0]?.distance;
  return (
    <div data-component="ProximityPolicyConstraintsEditor">
      <TitleSection
        id={`policy-proximity-constraint-settings`}
        title={t`Proximity Constraints Setup`}
        inSidebarView
        hasScreenTitle
      >
        <div className={`flex flex-col gap-4 p-2 xl:p-4`}>
          <PolicyCardItem
            key={`PolicyCardItem-group`}
            isDisabled
            // isActive={mode.id === selected}
            // onClick={() => onSelectValue(mode.id)}
            // iconClassName={`w-12 h-12 ltr:mr-2 rtl:ml-2`}
            title={
              getProximityConstraintTypeOptions(t).find(
                o => o.id === rule.constraint[0]?.constraintType,
              )?.title
            }
          />
          <InputNumber
            title={t`Distance`}
            value={distanceConstraints.distance}
            onChange={v => update({ distance: v })}
          />
          <InputCheckbox
            isSelected={distanceConstraints.includeHeightFromFloor}
            onChange={v => update({ includeHeightFromFloor: v })}
          >
            {t`Include Height from Floor (HFF)`}
          </InputCheckbox>
        </div>
      </TitleSection>
    </div>
  );
};

export default ProximityPolicyConstraintsEditor;
